<template>
  <v-container text-xs-center fill-height fluid v-show="this.players.length">
    <v-layout column fill-height>
      <v-layout row fill-height>
        <v-flex class="players_scores">
          <v-layout row fill-height nowrap>
            <v-flex class="targets">
              <h1 class="score">.</h1>
              <v-flex v-for="score in scores" :key="score.key">
                {{ score.key }}
              </v-flex>
            </v-flex>
            <player v-for="player in players" :player="player" :key="player.id"></player>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>

import { mapGetters } from 'vuex'
import Player from '@/components/Player'

export default {
  data: () => ({
    hasMany: false,
    column: null,
    row: null
  }),
  computed: {
    ...mapGetters([
      'getGameNumbers',
      'getPlayers'
    ]),
    scores () {
      return this.$store.state.game.scores
    },
    players () {
      return this.$store.state.game.players
    }
  },
  mounted () {
    this.hasMany = this.players.length > 2
  },
  components: {
    Player
  }
}
</script>
